<template>
    <div>
        <rkm-list
            :items="data.model.solicitacoesProcedimentosCirurgicos"
            hide-filters
            hide-pagination
        >
            <template v-slot="{item}">
                <rkm-row>
                    <rkm-col cols="6">
                        <strong>CID 10</strong> {{item.cid ? `${item.cid.codigo} - ${item.cid.nome}` : ''}}
                    </rkm-col>

                    <rkm-col cols="6">
                        <strong>CIAP 2</strong><br />{{item.ciap ? `${item.ciap.codigo} - ${item.ciap.descricao}` : ''}}
                    </rkm-col>

                    <rkm-col cols="12">
                        <strong>Classificação de risco</strong><br />{{item.classificacaoRiscoDescricaoEncaminhamento}}
                    </rkm-col>

                    <rkm-col cols="12">
                        <strong>Justificativa do procedimento</strong> {{item.justificativa}}
                    </rkm-col>

                    <rkm-col cols="12">
                        <strong>Observações</strong> {{item.observacao}}
                    </rkm-col>
                </rkm-row>
            </template>

            <template v-slot:trailling="{index, item}">
                <rkm-button
                    @click.stop="print(item)"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    @click.stop="$refs.Modal.open(item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click.stop="destroy(index)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>

            <template v-slot:collapse="{item}">
                <rkm-row class="p-2">
                    <rkm-col>
                        <rkm-table
                            :fields="fields"
                            :items="item.procedimentosCirurgicos"
                            hide-filters
                            hide-pagination
                        >
                            <template v-slot:cell(procedimentoCirurgico)="{item}">
                                {{`${formatProcedimento(item.codigo)} - ${item.nome}`}}
                            </template>
                        </rkm-table>
                    </rkm-col>
                </rkm-row>
            </template>
        </rkm-list>

        <rkm-area
            background-color="primary"
            closed
            title="Histórico de solicitações de procedimentos cirúrgicos"
            type="box"
        >
            <rkm-list
                :items="data.form.solicitacoesProcedimentosCirurgicos"
                hide-filters
                hide-pagination
            >
                <template v-slot="{item}">
                    <rkm-row>
                        <rkm-col>
                            <strong>Data / Hora</strong><br />{{item.dataHora}}
                        </rkm-col>

                        <rkm-col>
                            <strong>Setor</strong><br />{{item.centroCusto.setor.nome}}
                        </rkm-col>

                        <rkm-col>
                            <strong>Profissional</strong><br />{{item.lotacao.profissional.nome}} - {{item.lotacao.ocupacao.nome}}
                        </rkm-col>
                    </rkm-row>

                    <hr />

                    <rkm-row>
                        <rkm-col cols="6">
                            <strong>CID 10</strong><br />{{item.cidDescricao ?? '-'}}
                        </rkm-col>

                        <rkm-col cols="6">
                            <strong>CIAP 2</strong><br />{{item.ciapDescricao ?? '-'}}
                        </rkm-col>

                        <rkm-col cols="12">
                            <strong>Justificativa do procedimento</strong><br />{{item.justificativa}}
                        </rkm-col>

                        <rkm-col cols="12">
                            <strong>Observações</strong><br />{{item.observacao}}
                        </rkm-col>
                    </rkm-row>
                </template>

                <template v-slot:collapse="{item}">
                    <div class="p-2">
                        <rkm-row>
                            <rkm-col>
                                <rkm-table
                                    :fields="fields"
                                    :items="item.procedimentosCirurgicos"
                                    hide-filters
                                    hide-pagination
                                >
                                    <template v-slot:cell(procedimentoCirurgico)="{item}">
                                        {{item.descricao}}
                                    </template>
                                </rkm-table>
                            </rkm-col>
                        </rkm-row>
                    </div>
                </template>
            </rkm-list>
        </rkm-area>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Enums.
import complexidadeExame from '@/enums/ambulatorio/complexidadeExame'

// Mixins.
import {error, file, repository, formats, stringCase, object} from '@/mixins'

// Components.
import Modal from './Modal'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {Modal},
    data() {
        return {
            fields: [
                {key: 'procedimentoCirurgico', label: 'Procedimento cirúrgico', sortable: true},
            ],
        }
    },
    created() {
        this.repositories = {
            pdf: this.getConectaSusRepository('impressao.ambulatorio'),
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir a solicitação de procedimento cirúrgico?', async () => {
                this.data.model.solicitacoesProcedimentosCirurgicos.splice(index, 1)
            })
        },
        print(item) {

            item.emAtendimento = true
            item.atendimentoId = this.data.additionals.atendimentoId

            item.procedimentosCirurgicos.forEach(procedimentoCirurgico => {

                if (procedimentoCirurgico.complexidade == complexidadeExame.ALTA_COMPLEXIDADE) {

                    let dados = {
                        atendimento_id: this.data.additionals.atendimentoId,
                        paciente_id: this.data.additionals.paciente.id,
                        procedimento_cirurgico_id: procedimentoCirurgico.id,
                        procedimento_cirurgico_codigo: procedimentoCirurgico.codigo,
                        procedimento_cirurgico_nome: procedimentoCirurgico.nome,
                        classificacao_risco_id: item.classificacaoRiscoId,
                        justificativa_procedimento_solicitado_descricao_diagnostico: item.justificativa,
                        justificativa_procedimento_solicitado_cid_codigo: item.cid ? item.cid.codigo : null,
                        justificativa_procedimento_solicitado_cid_nome: item.cid ? item.cid.nome : null,
                        observacao_procedimento_solicitado_ciap_codigo: item.ciap ? item.ciap.codigo : null,
                        observacao_procedimento_solicitado_ciap_descricao: item.ciap ? item.ciap.descricao : null,
                        justificativa_procedimento_solicitado_observacoes: item.observacao,
                        solicitacao_documento: null,
                        solicitacao_numero_documento: null,
                    }

                    this.setLoading()

                    this.repositories.pdf.laudoSolicitacaoAutorizacaoProcedimentoAmbulatorial(null, {dados})
                        .then(({data, headers}) => this.openFile(data, headers['content-type']))
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                } else {

                    const itemData = this.clone(item)
                    itemData.procedimentosCirurgicos = itemData.procedimentosCirurgicos.filter(pc => pc.id === procedimentoCirurgico.id)

                    this.setLoading()

                    this.repositories.pdf.fichaRequisicaoServicoAuxiliarDiagnoseTerapia(this.data.additionals.paciente.id, this.camelObjectKeysToSnakeRecursive(itemData))
                        .then(({data, headers}) => this.openFile(data, headers['content-type']))
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                }
            })
        },
    },
    mixins: [error, file, repository, formats, stringCase, object],
    props: {
        data: {type: Object, required: true},
    },
}
</script>